<template>
  <div class="text-white">
    <div class="card border-0">
      <div class="card-body bg-dark">
        <div class="mb-2">
          EC2 Management
        </div>
        <div v-if="starting">
          <b-spinner label="Spinning"></b-spinner> Starting EC2 instance...
        </div>
        <div class="mb-3" v-if="instanceStatus">
          <span class="text-secondary">Instance State:</span> {{instanceStatus.instanceState}}<br>
          <span class="text-secondary">Instance Status:</span> {{instanceStatus.instanceStatus}}<br>
          <span class="text-secondary">System Status:</span> {{instanceStatus.systemStatus}}<br>
          <span class="text-secondary">API Status: </span> {{ apiStatus }}
        </div>
        <div v-else>
          <p class="text-danger">Instance not available</p>
        </div>
        <div>
          <b-button v-if="instanceStatus && instanceStatus.instanceState === 'running'" variant="danger" size="sm" @click="stopInstance()">Stop EC2 Instance</b-button>
          <b-button v-else class="mr-2" variant="primary" size="sm" @click="startInstance()">Start EC2 Instance</b-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ec2Service from "../api/ec2-service";

export default {
  name: "Ec2Management",
  data() {
    return {
      instanceStatus: null,
      statusInterval: null,
      starting: false,
      apiStatus: null
    }
  },
  methods: {
    async getStatus() {
      try {
        const res = await ec2Service.getStatus();
        if (res.code === 200) {
          this.instanceStatus = res.data;
          const apiResp = await ec2Service.getApiStatus();
          if (apiResp.status === 200) {
            this.apiStatus = "ok"
          }
          else{
            this.apiStatus = "Not Ok"
          }
        }
      }
      catch (e) {
        this.instanceStatus = null;
      }
    },
    async startInstance() {
      if (confirm('Are you sure you want to "START" EC2 Instance?')) {
        try {
          this.starting = true;
          const res = await ec2Service.startInstance();
          this.starting = false;
          if (res.code === 200) {
            alert(res.message);
          }
          else {
            alert(res.message);
          }
        }
        catch (e) {
          alert("Failed to start EC2 instance");
        }
      }
    },
    async stopInstance() {
      if (confirm('Are you sure you want to "STOP" EC2 Instance?')) {
        const res = prompt("Please enter 'stop' to STOP the instance", "")
        if (res === 'stop') {
          try {
            const res = await ec2Service.stopInstance();
            if (res.code === 200) {
              alert(res.message);
            }
            else {
              alert(res.message);
            }
          }
          catch (e) {
            alert("Failed to stop EC2 instance");
          }
        }
      }
    }
  },
  mounted() {
    this.getStatus();
    const ctx = this;
    this.statusInterval = setInterval(function () {
      ctx.getStatus();
    }, 5000);
  },
  destroyed() {
    clearInterval(this.statusInterval);
  }
}
</script>

